import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { PageHero, CTABand } from "@/components/Bits";

export default function Catalog() {
  const { categories } = useSite();
  return (
    <div>
      <PageHero eyebrow="Equipamentos" title="Portfólio completo de refrigeração industrial e comercial"
        subtitle="Fabricação sob encomenda. Portfólio amplo com investimento inicial enxuto — cada linha tem seu status de disponibilidade."
        image="https://images.unsplash.com/photo-1620203853151-496c7228306c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />
      <div className="mx-auto max-w-[1400px] px-4 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <Link key={c.slug} to={`/equipamentos/${c.slug}`} data-testid={`catalog-cat-${c.slug}`}
              className="group flex flex-col border border-[#27272A] bg-[#151618] transition-colors duration-200 hover:border-[#FF5500]">
              <div className="relative aspect-[16/10] overflow-hidden bg-black">
                <img src={c.image} alt={c.name} className="h-full w-full object-cover opacity-80 transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-xl font-bold text-white">{c.name}</h3>
                <p className="mt-2 text-sm text-[#A1A1AA]">{c.short}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <CTABand />
    </div>
  );
}
